export const FILTERS_FEATURE_NAME = 'filters';
